<div>
    <a href="javascript:void(0)" class="filter--dialog" role="button" tabindex="0" (click)="taxEfficiencyModalDialog.openModalDialog();"
        aria-label="What is tax efficiency title">What's a tax efficiency?</a>
    <div class="filter--checkboxes">
        <c11n-checkbox-group>
            <c11n-checkbox *ngFor="let label of taxEfficiencyFilterLabels" [labelText]="filterMap[label]"  [variant]="'default'" [descriptiveLabel]="'Extra checkbox content'" [labelWeight]="'normal'">
                <input c11nCheckboxInput [id]="label" type="checkbox" name="choices" [value]="label" [formControl]="taxEfficiencyGroup.controls[label]" />
            </c11n-checkbox>
        </c11n-checkbox-group>
    </div>
</div>

<c11n-modal-dialog modalId="taxEffeciencyModal" variant="basic" headingText="What's a tax efficiency?" #taxEfficiencyModalDialog>
    <div c11n-modal-dialog-body>
        <p class="rps-paragraph-one" id="whatisAssetClassDialogDesc" [innerHtml]="popupDescription" attr.data-aem-source="{{taxManaged?.isAEM | json}}"></p>
    </div>
</c11n-modal-dialog>